/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import * as React from 'react'
import classNames from 'classnames/bind'
import * as styles from './Text.scss'

const cx = classNames.bind(styles)

type Size = 'small' | 'medium' | 'large'

interface IProps {
  styleType?: string,
  children?: any,
  size?: Size,
  smSize?: Size,
}

const Text: React.FC<IProps> = ({ children, styleType, size = 'medium', smSize = size, ...restProps }) => {
  let component = React.createFactory('div')
  if (styleType === 'remark') {
    component = React.createFactory('sup')
  }

  return component({
    ...restProps,
    className: cx(
      'root',
      styleType,
      size,
      `sm-${smSize}`,
    ),
    children,
  })
}

export default Text
